export enum HistPriceVolStreamElementType {
    /*
     * Historical Price/Volume data
     */
    HistoricalData = 101,
    /*
     * Symbol reference data
     */
    SymbolData,
    /*
     * Today Price/Volume data
     */
    TodayData = 103,
}
